import tw, { styled } from 'twin.macro';

export const StyledArrow = styled.div`
	${tw`absolute w-4 h-4`}
	z-index:-1;

	&:after {
		${tw`absolute w-4 h-4 transform rotate-45 bg-gray-900`}
		content: ' ';
	}
`;

export const StyledTooltip = styled.div`
	${tw`px-3 py-1 bg-gray-900 rounded`}
	z-index: 555556;
`;
